import { collectionTableService } from "../services/collectionTable.service";

export const collectionTable = {
    namespaced: true,
    state: {
        collectionTables: []
    },
    actions: {
        getCollectionTables({ commit }) {
            //debugger;
            collectionTableService.getCollectionTables().then(collectionTables => {
                commit("setCollectionTables", collectionTables);
            });
        },
    },
    mutations: {
        setCollectionTables(state, collectionTables) {
            state.collectionTables = collectionTables;
        }
    }
};